export default {
  root: {
    padding: [10, 16],
  },
};
